// Phase 1 renders slots as labelled placeholder badges. No fill, no
// inspector, no AI — those land in Phase 2 (authoring) and Phase 5 (AI
// behaviors). The point is to make the slot directive visible in the
// editor surface so reviewers can see the policy shape baked into a
// cell template, even before the runtime exists.
//
// Accepts containerDirective (canonical multi-line `:::slot[X]\n:::`),
// textDirective (forward-compat for a future normalizeAgentMarkdown
// rule that demotes single-line slots), and leafDirective.

import type { DirectiveDescriptor } from '@mdxeditor/editor';
import { bracketLabelOf } from '@rmint/core/directives/bracket-label';

export const slotDirectiveDescriptor: DirectiveDescriptor<any> = {
  name: 'slot',
  testNode: (node: any) =>
    (node?.type === 'containerDirective' ||
      node?.type === 'textDirective' ||
      node?.type === 'leafDirective') &&
    node?.name === 'slot',
  attributes: ['schema', 'source', 'reviewer', 'slash', 'trigger', 'maxWords', 'maxBytes', 'maxItems', 'default'],
  hasChildren: false,
  Editor: ({ mdastNode }: any) => {
    const a = mdastNode?.attributes ?? {};
    const slotName = bracketLabelOf(mdastNode) || 'unnamed';
    const source = (a.source as string) ?? 'human';
    const reviewer = (a.reviewer as string) ?? 'none';
    return (
      <span
        data-testid={`slot-${slotName}`}
        data-slot-source={source}
        data-slot-reviewer={reviewer}
        className="rmint-slot-placeholder"
        style={{
          display: 'inline-block',
          padding: '2px 8px',
          margin: '0 4px',
          border: '1px dashed #888',
          borderRadius: 4,
          fontSize: '0.85em',
        }}
      >
        slot:{slotName}
        {source !== 'human' && ` (source=${source})`}
        {reviewer !== 'none' && ` (reviewer=${reviewer})`}
      </span>
    );
  },
};
